import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'
import { MONITORING_PRODUCT_STATUS } from '@app/api/constants'
import { TABLE_ROW_COLORS } from '@app/constants'

import { columnSettingSchema, columnTitleSchema } from '../configs'

import type { Column } from '@app/components/base/Table/types'
import type { ProductStatus, RegistryCurrentListDataSource } from '../types'

const getOptions = (): Array<Column<RegistryCurrentListDataSource>> => {
  const columnsKeys = Object.keys(columnTitleSchema).filter(key => !['isCHTM', 'subtypes'].includes(key)) as Array<
  keyof RegistryCurrentListDataSource
  >

  return columnsKeys.map(key => {
    const column: Column<RegistryCurrentListDataSource> = {
      key,
      sorter: (a, b) => sorterDispatcher(a[key], b[key]),
      ...columnSettingSchema[key]
    }

    return column
  })
}

export const getColumns = (): Array<Column<RegistryCurrentListDataSource>> => {
  return getColumnsFromMap<RegistryCurrentListDataSource>({
    columnTitleMap: columnTitleSchema,
    options: [
      ...getOptions(),
      {
        key: 'isCHTM',
        sorter: (a, b) => sorterDispatcher(a.isCHTM, b.isCHTM),
        render: (_, { isCHTM }) => (isCHTM ? 'Да' : '')
      },
      {
        key: 'subtypes',
        render: () => null
      }
    ]
  })
}

export const getCurrentListRowColorByStatus = (status: ProductStatus): string => {
  switch (status) {
    case MONITORING_PRODUCT_STATUS.ADDED:
      return TABLE_ROW_COLORS.green
    case MONITORING_PRODUCT_STATUS.CHANGED:
      return TABLE_ROW_COLORS.yellow
    case MONITORING_PRODUCT_STATUS.DELETED:
      return TABLE_ROW_COLORS.red
    default:
      return ''
  }
}
